module.exports = __webpack_public_path__ + "img/BateriaPanelDMP.4264af95.svg";